import * as React from "react";
const SvgFiRrSaturday = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-saturday_svg__a)">
      <path
        fill="#062147"
        d="M19 2h-1V1a1 1 0 1 0-2 0v1H8V1a1 1 0 1 0-2 0v1H5C2.243 2 0 4.243 0 7v12c0 2.757 2.243 5 5 5a1 1 0 1 0 0-2c-1.654 0-3-1.346-3-3v-9h20v3a1 1 0 1 0 2 0V7c0-2.757-2.243-5-5-5m3 6H2V7c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zm-9.137 13.972C12.672 23.147 11.648 24 10.427 24c-.664 0-1.3-.195-1.839-.552a.733.733 0 0 1-.119-1.131.73.73 0 0 1 .888-.111c.316.191.688.297 1.069.297.604 0 1.031-.404 1.096-.795.089-.55-.602-.873-.816-.959-.915-.371-1.751-.78-1.753-.78-.692-.484-1.027-1.231-.921-2.049a2.17 2.17 0 0 1 1.471-1.796c.839-.277 1.603-.076 2.152.203a.727.727 0 0 1 .238 1.095l-.011.014a.695.695 0 0 1-.831.216c-.308-.138-.72-.237-1.156-.096-.412.136-.517.447-.516.577.005.442.335.57.433.615.282.128.806.368 1.366.595 1.461.591 1.828 1.745 1.685 2.627zM24 16.792a.8.8 0 0 1-.8.8h-.95v5.601a.8.8 0 1 1-1.6 0v-5.601h-.851a.8.8 0 1 1 0-1.6h3.4a.8.8 0 0 1 .801.8m-7.825-.8c-1.098 0-1.626 1.002-1.742 1.581l-1.165 5.479a.777.777 0 0 0 1.519.329l.175-.79h2.379l.165.782c.076.36.437.617.804.617a.777.777 0 0 0 .761-.937l-1.142-5.435c-.135-.668-.655-1.627-1.753-1.627zm-.86 5 .686-3.104c.03-.149.105-.253.176-.296l.017.006c.024.016.121.118.168.349l.641 3.044h-1.688z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-saturday_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSaturday;
